import templateUrl from 'emun.salesrep/top-customers-full.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config'
import _ from 'underscore';

class TopCustomersFullController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		$ctrl.orderByField = 'ytdTotal';
		$ctrl.reverseSort = true;
		$ctrl.mode = "list";
		$ctrl.total = 0;
		$ctrl.utils = utils;
		$ctrl.repGroupFilter = '';
		$ctrl.label = $ctrl.title || "Top 50 Customers";
		if ($ctrl.repGroup !== 'ALL') {
			$ctrl.repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
		}
		var context = $ctrl.context || 'rep';

		var filter = "SalesRepID";
		if (context === 'manager') { filter = "ManagerId"; }
		if (context === 'vendor') { filter = "VendorId"; }
		if ($ctrl.context === 'executive') { filter = ''; }

		$ctrl.results = [];

    var salesQueryUrl = 'QueryCustomerSalesSummary.json?Fields=CustomerID,CustomerName,strRanking&GroupBy=CustomerID,CustomerName,strRanking&Sum=TotalSalesYearToDate,TotalSalesYearToDateLastYear,TotalSalesMonthToDate,TotalSalesMonthToDateLastYear';
		if ($ctrl.repGroup) {
			if ($ctrl.repGroup !== 'ALL') {
				salesQueryUrl = salesQueryUrl + '&RepGroupName=' + $ctrl.repGroup;
			}
		}
		if (context === 'writingRep') {
			if ($ctrl.salesRepId) {
				salesQueryUrl = salesQueryUrl + '&SalesRepID=' + $ctrl.salesRepId;
				filter = '';
			}
			else {
				if ($ctrl.writingRepId) {
					salesQueryUrl = salesQueryUrl + '&WritingRepID=' + $ctrl.writingRepId;
					filter = '';
				}
			}
		}
		else {
			if (filter !== '') {
				salesQueryUrl = salesQueryUrl + '&' + filter + '=' + $ctrl.rep.id;
			}
		}
		if ($ctrl.insideSales === 'true') {
			salesQueryUrl = salesQueryUrl + '&IsInsideSales=true';
		}

		$ctrl.salesQuery = createAutoQuery({
			url: salesQueryUrl,
			//orderBy: "-TotalSalesYearToDate",
			pageSize: 10000,
			autoLoad: true,
			onLoaded: function (args) {
				//$ctrl.chartLabels = [];
				//$ctrl.chartData = [];
				$ctrl.customers = [];
				args.results.forEach(function (sales) {
					var customer = {};
					customer.customerID = sales.customerID;
					customer.customerName = sales.customerName;
					customer.ytdTotal = sales.sumTotalSalesYearToDate;
					customer.lastytdTotal = sales.sumTotalSalesYearToDateLastYear;
					customer.mtdTotal = sales.sumTotalSalesMonthToDate;
					customer.lastmtdTotal = sales.sumTotalSalesMonthToDateLastYear;
					customer.monthGoal = 0;
					customer.goal = 0;
					customer.ytdGoal = 0;
					customer.percent = 0;
					customer.ranking = sales.strRanking;
					//$ctrl.chartLabels.push(sales.customerName);
					//$ctrl.chartData.push(Math.round(sales.ytdTotal));
					$ctrl.total += sales.ytdTotal;
					$ctrl.customers.push(customer);
        });
        $ctrl.sortedCustomers = _.sortBy($ctrl.customers, 'ytdTotal').reverse().slice(0, 25);
        $ctrl.sortedCustomersALL = _.sortBy($ctrl.customers, 'ytdTotal').reverse().slice(0, 10000);
				var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth&GroupBy=VendorName&OrderBy=VendorName';
				if ($ctrl.repGroup) {
					if ($ctrl.repGroup !== 'ALL') {
						salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
					}
				}
				//if (filter !== '') {
				//  salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
				//}
				if (context !== 'writingRep') {
					if (filter !== '') {
						salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
					}
				}
				else {
					if ($ctrl.writingRepId) {
						salesGoalsUrl = salesGoalsUrl + '&WritingRep=' + $ctrl.writingRepId;
					}
				}
				if ($ctrl.insideSales === 'true') {
					// salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=true';
				}
				else {
					salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
				}

				if ((context === 'writingRep') || ($ctrl.insideSales === 'true')) {
					//do nothing because we have no goals per vendor for inside sales
				}
				else //standard
				{

					$ctrl.salesGoals = createAutoQuery({
						url: salesGoalsUrl,
						autoLoad: true,
						pageSize: 1000,
						onLoaded: function (args) {
							args.results.forEach(function (goals) {
								$ctrl.vendors.results.forEach(function (vendor, index) {
									if (vendor.ytdTotal > 0 && vendor.label === goals.vendorName) {
										//console.info("vendorInfo", vendor.label, vendor.ytdTotal, goals.sumSalesGoalThisYear);
										vendor.goal = goals.sumSalesGoalThisYear || 0;
										vendor.monthGoal = goals.sumSalesGoalThisMonth || 0;
										if (vendor.goal > 0) {
											vendor.percent = Math.round((vendor.ytdTotal / vendor.goal) * 100);
										} else {
											vendor.percent = 0;
										}
									}
								});
							});

							//remove empty records
						}
					});
				}
				$ctrl.isBusy = false;
			}
		});

		$ctrl.isBusy = true;
	}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			customerName: 'Name',
			mtdTotal: "MTD Sales",
			monthGoal: "Month Goal",
			lastmtdTotal: "MTD LY",
			ytdTotal: "YTD Sales",
			goal: "Year Goal",
			percent: "% of Goals",
			lastytdTotal: "Last YTD"
		};

		// format the data
		$ctrl.customers.forEach((item) => {
			itemsFormatted.push({
				customerName: item.customerName.replace(/,/g, ''), // remove commas to avoid errors,
				mtdTotal: item.mtdTotal,
				monthGoal: item.monthGoal,
				lastmtdTotal: item.lastmtdTotal,
				ytdTotal: item.ytdTotal,
				goal: item.goal,
				percent: item.percent,
				lastytdTotal: item.lastytdTotal
			});
		});

		var fileTitle = 'top-customers';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'ytdTotal').reverse(), fileTitle);
	}
}

let TopCustomersFull = {
	bindings: {
		rep: '<',
		repGroup: '@',
		context: '@',
		title: '@',
		insideSales: '@',
		writingRepId: '@',
		salesRepId: '@'
	},
	controller: TopCustomersFullController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default TopCustomersFull